import { render, staticRenderFns } from "./SalesPersonSelectDialog.vue?vue&type=template&id=3a885458&scoped=true"
import script from "./SalesPersonSelectDialog.vue?vue&type=script&lang=js"
export * from "./SalesPersonSelectDialog.vue?vue&type=script&lang=js"
import style0 from "./SalesPersonSelectDialog.vue?vue&type=style&index=0&id=3a885458&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a885458",
  null
  
)

export default component.exports